import { useState } from "react"
import { HomeIcons, NotificationIcons, TcIcons, MyToolIcons, ReferUserIcons, RenewIcons, List1, Wand1, StickyNote1, StickyNoteFill1, WandFill1, ListFill1, Report, ChartLineUpIcon, GlobeIcon } from '../../global/Icons';
import { Settings, Campaign, /* Business, */ ManageAccounts } from "@mui/icons-material";

export const NavigationStates = () => {
    const [tabs, setTabs] = useState({
        top: [
            {name:'Notifications', className:'', subdir:'/notification', ref: '/notification', not_active: <NotificationIcons fill="#333333" />, active: <NotificationIcons fill="#107038" />},
            {name:'MyTools', step: 'mytools', className:'tenth-step', subdir:'#', ref: '__mytools', not_active:<MyToolIcons fill="#292D32" />, active:<MyToolIcons fill="#107038" stroke="#107038"/>},
        ],
        mtop: [
            {name:'Notifications', className:'', subdir:'/notification', ref: '/notification', not_active: <NotificationIcons fill="#fff" />, active: <NotificationIcons fill="#fff" />},
            {name:'MyTools', className:'tenth-step', subdir:'#', ref: '__mytools', not_active:<MyToolIcons fill="#FFFFFF" stroke="#FFFFFF" />, active:<MyToolIcons fill="#107038" stroke="#107038"/>},
        ],
		// FOR NON BD
		left: [
			{
				parent: { name: 'Campaign', step:'campaign', subdir: '', ref: 'campaign', not_active: <Campaign sx={{color: '#89A594'}} width={24} height={24} />, active: <Campaign sx={{color: '#165320'}} width={24} height={24} /> },
				items: [
					{ name: 'Creative Brief', step:'creative-brief', subdir: '/campaign/creative-brief?mode=list&subft=product', ref: 'creative-brief' },
					{ name: 'Promo', step:'promo', subdir: '/campaign/promo?type=service', ref: 'promo', industries: [1,2], alias: 'campaign-promo' },
                    { name: 'Poster', step:'poster', subdir: '/campaign/poster?type=training', ref: 'poster', industries: [1,2,3,4], alias: 'campaign-poster' },
					// { name: 'Sales Page', step:'sales-page', subdir: '/campaign/sales-page?type=real-property', ref: 'sales-page' },
					{ name: 'Call Monitoring', step:'call-monitoring', subdir: '/campaign/call-monitoring?type=record&subft=product', ref: 'call-monitoring' },
					// { name: 'Email Sequences', step:'email-sequences', subdir: '/campaign/email-sequences?industry=product&type=app-maker&mode=list', ref: 'email-sequences' },
				]
			},
			{
				parent: { name: 'Sales', step:'sales', subdir: '', ref: 'sales', not_active: <ChartLineUpIcon stroke="#89A594"/>, active: <ChartLineUpIcon stroke="#165320"/> },
				items: [
					{ name: 'Product', step:'product', subdir: '/sales/product?tab=received', ref: 'product', industries: [1] },
					{ name: 'Booking', step:'booking', subdir: '/sales/booking?subft=booking&tab=1', ref: 'booking', industries: [2] },
					{ name: 'Training', step:'training', subdir: '/sales/training', ref: 'training', industries: [4] },
                    { name: 'Membership', step:'membership', subdir: '/sales/membership', ref: 'membership', industries: [3] },
				]
			},
			{
				parent: { name: 'Leads Management', step:'lm', subdir: '', ref: 'lm', not_active: <ManageAccounts sx={{color: '#89A594'}} width={24} height={24} />, active: <ManageAccounts sx={{color: '#165320'}} width={24} height={24} /> },
				items: [
					{ name: 'Inquiries', step:'inquiries', subdir: '/lm/inquiries', ref: 'inquiries' },
					{ name: 'Property Inquiries', step:'property-inquiries', subdir: '/lm/property-inquiries', ref: 'property-inquiries' },
					{ name: 'Agent Application', step:'agent-application', subdir: '/lm/agent-application', ref: 'agent-application' },
				]
			},
            // {
			// 	parent: { name: 'Business Development', step:'bd', subdir: '', ref: 'bd', not_active: <Business sx={{color: '#89A594'}} width={24} height={24} />, active: <Business sx={{color: '#165320'}} width={24} height={24} /> },
			// 	items: [
			// 		{ name: 'Leads', step:'leads', subdir: '/bd/leads', ref: 'leads' },
			// 		{ name: 'Clients', step:'clients', subdir: '/bd/clients', ref: 'clients' },
			// 		{ name: 'Proposals', step:'proposals', subdir: '/bd/proposals', ref: 'proposals' },
			// 		{ name: 'Tasks & Approvals', step:'tasks-approvals', subdir: '/bd/tasks-approvals', ref: 'tasks-approvals' },
			// 		{ name: 'Reports', step:'reports', subdir: '/bd/reports', ref: 'reports' },
			// 		{ name: 'Targets', step:'targets', subdir: '/bd/targets', ref: 'targets' },
			// 	]
			// },
			{
				parent: { name: 'Setup', step:'setup', subdir: '', ref: 'setup', not_active: <Settings sx={{ color: '#89A594'}}/>, active: <Settings sx={{ color: '#165320'}}/> },
				items: [
					{ name: 'Contacts', step:'contacts', subdir: '/setup/contacts?subft=product', ref: 'contacts', alias: 'setup-contact' },
					{ name: 'Real Property', step:'real-property', subdir: '/setup/real-property?type=property-listing', ref: 'real-property' },
					{ name: 'Training', step:'training', subdir: '/setup/training', ref: 'training', industries: [4] },
					{ name: 'Membership', step:'membership', subdir: '/setup/membership', ref: 'membership', industries: [3] },
				]
			},
			{
				parent: { name: 'Online Solutions', step:'ol', subdir: '', ref: 'ol', not_active: <GlobeIcon stroke='#89A594'/>, active: <GlobeIcon stroke='#165320'/> },
				items: [
					{ name: 'E-commerce Store', step:'ecs', subdir: '/ol/ecs?type=real-property&tab=list&offer_type=rent&property_type=all', ref: 'ecs' },
				]
			},
			{
				parent: { name: 'Reports', step:'reports', subdir: '', ref: 'reports',  not_active: <Report stroke="#89A594" width={24} height={24} />, active: <Report stroke="#165320" width={24} height={24} /> },
				items: [
					{ name: 'Call Record', step:'campaign', subdir: '/reports/campaign?type=call-monitoring&subft=product', ref: 'campaign' },
					{ name: 'Sales', step:'sales', subdir: '/reports/sales?type=booking', ref: 'sales', industries: [1,2], alias: 'reports-sales' },
					{ name: 'Payment', step:'payment', subdir: '/reports/payment?type=booking&tab=for-payment', ref: 'payment', industries: [1,2,4], alias: 'reports-payment' },
					{ name: 'Reviews & Ratings', step:'reviews-ratings', subdir: '/reports/reviews-ratings?type=service', ref: 'reviews-ratings', industries: [1,2], alias: 'reports-reviewsratings' },
                    { name: 'Social Media Insight', step:'social-media-insight', subdir: '/reports/social-media-insight?state=facebook', ref: 'social-media-insight' },
					{ name: 'Facebook Posts', step:'facebook-posts',  subdir:'/reports/facebook-posts', ref: 'facebook-posts', not_active:<Settings stroke="#89A594" />, active:<Settings fill="#107038" stroke="#107038"/> },
				]
			},
			{
				parent: { name: 'Integrations', step:'integrations', subdir: '', ref: 'integrations',  not_active: <Settings sx={{ color: '#89A594'}}/>, active: <Settings sx={{ color: '#165320'}}/>},
				items: [
					{ name: 'Facebook Integration', step:'facebook-settings',  subdir:'/integrations/facebook-settings', ref: 'facebook-settings', not_active:<Settings stroke="#89A594" />, active:<Settings fill="#107038" stroke="#107038"/> },
				]
			},
		],
        service_cmztn: [
            { name: '', step: 'promoBookingFourthStep', subdir: '?step=1', ref: '1', not_active: <List1 stroke="#8EAF9E" width={20} />, active: <ListFill1 fill="#009F4D" width={20} /> },
            { name: '', step: 'promoBookingFifthStep', subdir: '?step=2', ref: '2', not_active: <Wand1 fill="#8EAF9E" width={20} />, active: <WandFill1 fill="#009F4D" width={20} /> },
            { name: '', step: 'promoBookingSixthStep', subdir: '?step=3', ref: '3', not_active: <StickyNote1 stroke="#8EAF9E" width={20} />, active: <StickyNoteFill1 fill="#009F4D" width={20} /> },
        ],
        procustomization: [
            { name: '', subdir: '?prodstep=1', ref: '1', not_active: <List1 stroke="#8EAF9E" width={20} />, active: <ListFill1 fill="#009F4D" width={20} /> },
            { name: '', subdir: '?prodstep=2', ref: '2', not_active: <Wand1 fill="#8EAF9E" width={20} />, active: <WandFill1 fill="#009F4D" width={20} /> },
            { name: '', subdir: '?prodstep=3', ref: '3', not_active: <StickyNote1 stroke="#8EAF9E" width={20} />, active: <StickyNoteFill1 fill="#009F4D" width={20} /> },
        ],
        msetting: [
            {name:'Refer a Hero Users', subdir:'/', ref: 'biz', steps: 'sixth-step', not_active:<ReferUserIcons fill="#fff" stroke="#A2A3A9"/>, active:<ReferUserIcons fill="#333333" stroke="#333333"/>},
            {name:'System Updates', subdir:'/', ref: 'biz', steps: 'seventh-step', not_active:<RenewIcons fill="none" stroke="#89A594"/>, active:<RenewIcons fill="#333333" stroke="#333333"/>},
        ],
        mobile: [
            {name:'Dashboard', sub_name:'', subdir:'/campaign/promo?type=service', ref: 'campaign', steps:'first-step', not_active:<HomeIcons stroke="#89A594" />, active:<HomeIcons fill="#11783C" stroke="#FFFFFF"/>},
            {name:'Tool Categories', sub_name:'', steps:'fourth-step', subdir:'/tool-categories/subscribed', ref: 'tool-categories', not_active:<TcIcons stroke={'#89A594'}  fill={'#fff'} />, active:<TcIcons fill="#107038" stroke="#107038"/>},
        ]
    })
    const [tc, setTc] = useState({open: true, list: false})
    const [leftBar, setLeftbar] = useState(true)
    const [notif,  setNotif] = useState(false)
    const [myTool, setMyTool] = useState(false)

    return {
        tabs: {data: tabs, set: setTabs},
        tc: {data: tc, set: setTc},
        leftBar: {data: leftBar, set: setLeftbar},
        notif: {data: notif, set: setNotif},
        myTool: {data: myTool, set: setMyTool},
    }
}